import { orderClient, useQuery } from "@trueskin-web/apis"

import usePreferredPreset from "./use-preferred-preset"

const useCurrentPresets = () => {
  const { preferredPreset } = usePreferredPreset()

  return useQuery(["currentPresets", preferredPreset], () =>
    orderClient.getCurrentPresets(preferredPreset, {
      enabled: !!preferredPreset,
    })
  )
}

export default useCurrentPresets
